import {Controller} from "stimulus"
import GoogleMapController from "./google_map_controller"
import EventEmitter from "../utils/EventEmitter"
import DOMUtils from "../utils/DOMUtils"
import defaultMapStyle from "../utils/defaultMapStyle.js"

export default class extends GoogleMapController {

    static targets = [
        "map",
        "panel",
        "panelItemsList",
        "close",
        "addressInput",
        "zipcodeInput",
        "cityInput",
        "countryInput",
        "latInput",
        "lngInput",
        "errorDiv",
    ]

    initialize() {

        super.initialize()

        EventEmitter.on(`googleMapCreated${this.id}`, e => {

            this.mapBounds = new this.googleMap.google.maps.LatLngBounds()

            this.makeMarkers()

        })

    }

    makeMarkers() {

        const w = 35
        const h = 60

        const posts = this.posts

        if ( posts && posts.length ) {

            let markers = posts.map(el => {
                return el.posts.map(subEl => {
                    const icon = {
                        url: subEl.icon, // url
                        scaledSize: new this.googleMap.google.maps.Size(w, h), // scaled size
                        origin: new this.googleMap.google.maps.Point(0, 0), // origin
                        anchor: new this.googleMap.google.maps.Point(w / 2, h) // anchor
                    }

                    return {
                        ...subEl,
                        coords: {lat: parseFloat(subEl.coords.lat), lng: parseFloat(subEl.coords.lng)},
                        icon,
                    }
                })
            }).flat()

            this.googleMap.setMarkers(markers)

            this.googleMap.makeMarkers()

        }

    }

    makeLines() {

        if (this.posts) {

            this.posts.forEach(item => {

                const coords = item.posts.map(el => {
                    return {
                        lat: parseFloat(el.coords.lat),
                        lng: parseFloat(el.coords.lng),
                    }
                })

                const flightPath = new this.googleMap.google.maps.Polyline({
                    path: coords,
                    geodesic: true,
                    strokeColor: item.road.color ? item.road.color : '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 4
                })

                flightPath.setMap(this.googleMap.map)

            })

        }

    }


    replaceCardsInDOM(markers) {

    }

    getCardHTML(data) {
        console.log(data);

        return `
            <div class="map-panel__el">
                <a href="${data.road.url}" class="map-panel__item road road_small u-mar-b-20" style="border-top: 3px solid ${data.road.color}; border-bottom: 3px solid ${data.road.color};"><span style="color: ${data.road.color};">${data.road.title}</span></a>
                <a href="${data.url}" class="map-panel__item surrounded surrounded_big u-mar-b-20">${data.title}</a>
                <a href="${data.institut.url}" class="map-panel__item island island-small u-mar-b-20">${data.institut.title}</a>
                <a href="${data.url}" class="map-panel__item blue-img">${data.image ? `<img src="${data.image}">` : ''}</a>
            </div>
        `

    }

    closePannel(){
        let $activePannels = [...document.querySelectorAll('.side-pannel')]
        $activePannels.forEach($item => $item.classList.remove("is-active"))
    }

    openPanel() {
        this.element.classList.add("is-opened")
        document.body.classList.add("is-opened")
    }

    close() {
        console.log("coucou")
    }

    findPlace() {
        const addressValue = this.addressInputTarget.value
        const zipcodeValue = this.zipcodeInputTarget.value
        const cityValue = this.cityInputTarget.value
        const countryValue = this.countryInputTarget.value
        const $latInput = this.latInputTarget
        const $lngInput = this.lngInputTarget
        const fullAddress = addressValue + ' ' + zipcodeValue + ' ' + cityValue + ' ' + countryValue
        $latInput.value = ""
        $lngInput.value = ""
        this.getLatitudeLongitude(fullAddress, (result) => {
            console.log("result", result)
            const lat = result.geometry.location.lat()
            const lng = result.geometry.location.lng()
            $latInput.value = lat
            $lngInput.value = lng
            this.googleMap.config.centerPosition = {lat, lng}
            this.googleMap.map.setCenter(result.geometry.location)
            this.googleMap.map.setZoom(16)
            this.googleMap.createCenterMarker()
        })
    }

    getLatitudeLongitude(address, callback) {
        const geocoder = new google.maps.Geocoder();
        if (geocoder) {
            geocoder.geocode({'address': address},  (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    this.errorDivTarget.classList.remove("google-map-no-results")
                    callback(results[0])
                } else {
                    if (status === 'ZERO_RESULTS') {
                        console.log("zéro results")
                        this.errorDivTarget.classList.add("google-map-no-results")
                    }
                    return status
                }
            });
        }
    }

    get posts() {
        let data = this.data.get("posts")
        return data && data !== "" ? JSON.parse(data) : false
    }

    get options() {
        return {
            makeCenterMarker: false,
            withCustomStyle: true,
            mapDiv: this.mapTarget,
            onMarkersLoop: marker => {
                this.googleMap.addMarker({lat: marker.coords.lat, lng: marker.coords.lng}, marker)
                this.mapBounds.extend(marker.coords)
            },
            callbackMarkerClick: marker => {

                let sidePannel = "side-pannel-" + marker.id

                let sidePannelElement = document.getElementsByClassName(sidePannel)[0]

                let activePannel = document.getElementsByClassName('side-pannel is-active')[0]

                if (activePannel) {
                    activePannel.classList.toggle("is-active")
                }

                sidePannelElement.classList.toggle("is-active")

            },
            centerPosition: {
                lat: 50.5,
                lng: 4.4
            }
        }

    }

    get googleMapOptions() {
        const zoom = 3.2
        return {
            zoom: 7, maxZoom: 20, minZoom: 3.2, zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeControlOptions: false,
            gestureHandling: 'cooperative',
            style: defaultMapStyle
        }
    }


}